document.addEventListener("DOMContentLoaded", () => {
  // Respecte les préférences d'accessibilité
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  /* ---- 0. Applique automatiquement l'apparition en douceur à toutes les sections du site ---- */
  /* (on exclut l'en-tête et le pied de page, qui doivent toujours rester visibles) */
  document.querySelectorAll(".shopify-section").forEach((el) => {
    if (el.closest("#header-group") || el.closest("footer")) return;
    el.classList.add("gold-fade-section");
  });

  /* ---- 1. Révélation au scroll (photos, sections, séparateurs) ---- */
  const revealTargets = document.querySelectorAll(
    ".gold-image-reveal, .gold-fade-section, .gold-divider"
  );
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  revealTargets.forEach((el) => revealObserver.observe(el));

  /* ---- 2. Poussière de fée légère au scroll (throttlée) ---- */
  let lastParticleTime = 0;
  const particleThrottleMs = 120; // limite la fréquence pour rester subtil

  function spawnParticle(x, y) {
    const p = document.createElement("div");
    p.className = "fairy-particle";
    p.style.left = `${x}px`;
    p.style.top = `${y}px`;
    document.body.appendChild(p);
    setTimeout(() => p.remove(), 1100);
  }

  window.addEventListener("scroll", () => {
    const now = Date.now();
    if (now - lastParticleTime < particleThrottleMs) return;
    lastParticleTime = now;

    const x = Math.random() * window.innerWidth;
    const y = Math.random() * (window.innerHeight * 0.4) + 40;
    spawnParticle(x, y);
  });

  /* ---- 3. Petites particules sur interactions ciblées (ex: clic sur un bijou) ---- */
  document.querySelectorAll(".gold-hover-halo, .gold-button").forEach((el) => {
    el.addEventListener("click", (e) => {
      for (let i = 0; i < 5; i++) {
        setTimeout(() => {
          spawnParticle(
            e.clientX + (Math.random() * 30 - 15),
            e.clientY + (Math.random() * 30 - 15)
          );
        }, i * 60);
      }
    });
  });

  /* ---- 4. Dissolution en poussière de fée quand un élément sort par le haut de l'écran ---- */
  const dissolveTargets = Array.from(
    document.querySelectorAll(
      ".shopify-section, .product-card, .collection-card, .divider, .text-block, .resource-image"
    )
  ).filter((el) => !el.closest("#header-group") && !el.closest("footer"));

  let dissolveTicking = false;

  function checkDissolve() {
    dissolveTargets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.height === 0) return;

      // L'élément est en train de sortir par le haut : on déclenche la dissolution
      if (rect.bottom > -20 && rect.bottom < 140 && !el.classList.contains("gold-dissolving")) {
        el.classList.add("gold-dissolving");
        for (let i = 0; i < 6; i++) {
          setTimeout(() => {
            const x = rect.left + Math.random() * rect.width;
            const y = Math.max(rect.top, 0) + Math.random() * 20;
            spawnParticle(x, y);
          }, i * 40);
        }
      }

      // Une fois bien hors champ (ou revenu en dessous), on réinitialise pour que
      // l'effet puisse rejouer si l'utilisateur remonte puis redescend
      if (rect.top > window.innerHeight * 1.1 || rect.bottom < -50) {
        el.classList.remove("gold-dissolving");
      }
    });
    dissolveTicking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!dissolveTicking) {
        window.requestAnimationFrame(checkDissolve);
        dissolveTicking = true;
      }
    },
    { passive: true }
  );
});
